var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{ref:"permitsduetable",attrs:{"table-ref":"permitsduetable","title":"Permits Due Report","icon":"fa fa-list","url":"/permits","fields":_vm.fields,"sort-field":"expiry","detail-component":"permits-detail-row"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('events-calendar',{attrs:{"category":"permits"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }